export function FrequencyToggle({ frequency, onChange }) {
  return (
    <div className="flex justify-center mb-8">
      <div className="inline-flex border border-zinc-300 rounded-none overflow-hidden">
        <button
          onClick={() => onChange("one_time")}
          data-testid="donate-frequency-one-time"
          className={`px-6 py-2.5 text-sm font-semibold transition-colors ${frequency === "one_time" ? "bg-zinc-950 text-white" : "bg-white text-zinc-600 hover:bg-zinc-50"}`}
        >
          Give Once
        </button>
        <button
          onClick={() => onChange("monthly")}
          data-testid="donate-frequency-monthly"
          className={`px-6 py-2.5 text-sm font-semibold transition-colors ${frequency === "monthly" ? "bg-zinc-950 text-white" : "bg-white text-zinc-600 hover:bg-zinc-50"}`}
        >
          Give Monthly
        </button>
      </div>
    </div>
  );
}
